import { render, staticRenderFns } from "./CommonTestimonialsBlock.vue?vue&type=template&id=5bbceb4e&scoped=true&"
import script from "./CommonTestimonialsBlock.vue?vue&type=script&lang=ts&"
export * from "./CommonTestimonialsBlock.vue?vue&type=script&lang=ts&"
import style0 from "./CommonTestimonialsBlock.vue?vue&type=style&index=0&id=5bbceb4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbceb4e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonVideoPlayerDialog: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonVideoPlayerDialog.vue').default})
